// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pagination-container {
  margin-top: var(--spacing-regular);
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/components/Pagination/Pagination.less"],"names":[],"mappings":"AAAA;EACI,kCAAA;AACJ","sourcesContent":[".pagination-container {\n    margin-top: var(--spacing-regular);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
